<div class="wrapper">
  <app-page-info
    [resourceName]="advertisementIntegrationsPageResourceParams.name"
    [loginAndRoles]="loginAndRoles"
  />
  <app-records-table-container
    class="app-records-table-container"
    [resourceParams]="advertisementIntegrationsPageResourceParams"
    [defaultSort]="[ 'id,desc' ]"
    [defaultFilters]="filtersValues()"
  />
</div>
